// extracted by mini-css-extract-plugin
export default {"zoomModal":"j0-z","image":"k0-z","button":"l0-z","isOverlayShown":"m0-z"};